import React from 'react'
import {Select, MenuItem, ListItem} from '@material-ui/core'
import {
  FormatAlignCenter,
  FormatAlignLeft,
  FormatAlignJustify,
  FormatAlignRight,
} from '@material-ui/icons'
import useStyles from './TTextAlign.styles'

const TTextAlign = props => {
  const classes = useStyles()

  return (
    <ListItem
      className={classes.root}
      defaultValue={props.value || 'left'}
      value={props.value || 'left'}
      onChange={props.onChange}
      component={Select}
    >
      <MenuItem value="left">
        <FormatAlignLeft className={classes.option} />
      </MenuItem>
      <MenuItem value="right">
        <FormatAlignRight className={classes.option} />
      </MenuItem>
      <MenuItem value="center">
        <FormatAlignCenter className={classes.option} />
      </MenuItem>
      <MenuItem value="justify">
        <FormatAlignJustify className={classes.option} />
      </MenuItem>
    </ListItem>
  )
}

export default TTextAlign
